
import { defineComponent } from 'vue'
import { UiProgressLinear } from '../keen-ui'

export default defineComponent({
  name: 'ExplainHeaderLayout',
  components: {
    UiProgressLinear,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    return {
      baseClass: 'epb-explain-header-layout',
    }
  },
})
